
export class SharePointResourceUpdateModel {
  userId: string|null;
  name: string;
}
